import * as T from 'three';
const clamp=x=>Math.max(0,Math.min(1,x));
export function accentPose(phase,age,reduced=false){
 const opening=phase==='revealed',start=opening?.285:1.8,duration=opening?.88:.42;
 const u=(age-start)/duration,visible=!reduced&&['rolling','revealed'].includes(phase)&&u>=0&&u<1;
 return {visible,u:clamp(u),opening,opacity:visible?Math.sin(Math.min(1,u*7)*Math.PI/2)*(1-u)**1.5:0};
}
// Two reused draws: a thin expanding halo and a small set of pastel glints.
// No textures, lights, shadows, timers or per-frame geometry allocations.
export class GachaAccent {
 constructor(){
  this.group=new T.Group();this.group.visible=false;
  const shape=new T.Shape();shape.moveTo(0,1);shape.lineTo(.19,.19);shape.lineTo(1,0);shape.lineTo(.19,-.19);shape.lineTo(0,-1);shape.lineTo(-.19,-.19);shape.lineTo(-1,0);shape.lineTo(-.19,.19);shape.closePath();
  this.glints=new T.InstancedMesh(new T.ShapeGeometry(shape),new T.MeshBasicMaterial({transparent:true,depthWrite:false,side:T.DoubleSide}),20);
  this.glints.frustumCulled=false;this.glints.renderOrder=3;
  const colors=['#c29adb','#ebc87e','#e2a3b9','#99c9cc'];
  for(let i=0;i<20;i++)this.glints.setColorAt(i,new T.Color(colors[i%colors.length]));
  this.ring=new T.Mesh(new T.RingGeometry(.975,1,64),new T.MeshBasicMaterial({color:'#c7add9',transparent:true,depthWrite:false,side:T.DoubleSide}));
  this.ring.renderOrder=2;this.group.add(this.ring,this.glints);
  this.matrix=new T.Matrix4();this.rotation=new T.Quaternion();this.twist=new T.Quaternion();this.position=new T.Vector3();this.size=new T.Vector3();this.axis=new T.Vector3(0,0,1);
 }
 update(phase,age,reduced,camera){
  const p=accentPose(phase,age,reduced);this.group.visible=p.visible;if(!p.visible)return;
  const {u,opening}=p,spread=1-(1-u)**3;
  this.group.position.set(opening?.08:0,opening?1.15:.49,opening?.65:1.02);
  this.glints.material.opacity=p.opacity*(opening?.85:.65);
  this.ring.material.opacity=p.opacity*.32;
  this.ring.quaternion.copy(camera.quaternion);this.ring.scale.setScalar((opening?.3:.1)+spread*(opening?1.1:.44));
  this.glints.count=opening?20:8;
  for(let i=0;i<this.glints.count;i++){
   const angle=i*2.399963,variation=.7+(i%5)*.1,radius=(opening?.32:.1)+spread*(opening?1.25:.46)*variation;
   this.position.set(Math.cos(angle)*radius,Math.sin(angle)*radius*(opening?.76:.45)-u*u*.18,(i%3-1)*.08);
   // Orient the whole burst in the camera plane, including its trajectories.
   this.position.applyQuaternion(camera.quaternion);
   this.twist.setFromAxisAngle(this.axis,angle+u*(i%2?1:-1));this.rotation.copy(camera.quaternion).multiply(this.twist);
   const size=(opening?.045:.025)*(1+(i%3)*.3)*Math.sin(Math.PI*.5*Math.min(1,u*9))*(1-u);
   this.size.setScalar(Math.max(.00001,size));
   this.matrix.compose(this.position,this.rotation,this.size);this.glints.setMatrixAt(i,this.matrix);
  }
  this.glints.instanceMatrix.needsUpdate=true;
 }
}
